const doc = [({"da":({"js":({"live_streaming_feeds":({"broadcaster":({"settings":({"audio_input":"Lydinput", "video_input":"Videoinput"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;